<template>
  <section>
    <p class="gp-section-title">
      <span>{{ position }}</span
      >Zusammenstellung
    </p>

    <div class="g-pb-10" v-if="description">
      <p class="gea-two-column-description">
        {{ description }}
      </p>
    </div>

    <div class="gp-2-column">
      <div class="gp-left-column">
        <!-- <section-content :title="mainTitle" :body="body"></section-content> -->
        <product-quantity-list
          title="Dachbahn"
          :options="dachbahnVariations"
          :meterware="true"
          attributeName="Bahnbreite ElastoTop"
          :highlightChoices="true"
        >
          <template #top>
            <div class="g-flex g-justify-between g-pt-2 g-pb-5" v-if="roofArea">
              <div class="g-w-1/2 g-pr-2">
                <p class="g-font-bold">Benötigte Fläche</p>
                <p class="g-text-2xl g-font-bold">{{ roofArea | formatPrice }} m&#178;</p>
              </div>
              <div class="g-w-1/2 g-pr-2">
                <p class="g-font-bold">Fläche der gewählten Bahn</p>
                <p class="g-text-2xl g-font-bold g-text-green-400">{{ chosenArea | formatPrice }} m&#178;</p>
              </div>
            </div>

            <div class="g-py-2 g-hidden">
              <p class="g-text-green-500 g-text-xl g-mb-1">
                Errechnete Bahnenempfehlung <span class="g-text-grey-500 g-text-sm">(Länge x Breite)</span>
              </p>
              <div class="g-flex">
                <p class="g-mr-1"><strong>6,80m</strong></p>
                <p>x <strong>4,58m</strong></p>
                <p>= 12,00m&#178;</p>
              </div>
              <div class="g-flex">
                <p class="g-mr-1"><strong>6,80m</strong></p>
                <p>x <strong>4,58m</strong></p>
                <p>= 12,00m&#178;</p>
              </div>
            </div>

            <p class="g-text-lg g-mb-2 g-mt-3">Bahnen Zusammenstellen</p>
          </template>
        </product-quantity-list>
      </div>

      <div class="gp-right-column">
        <div class="g-flex g-justify-between g-text-white g-rounded-t g-overflow-hidden" v-if="glueChoices.length > 1">
          <div
            class="g-w-1/3 g-cursor-pointer g-text-center g-uppercase g-font-bold g-bg-green-500 g-px-4 g-py-3"
            :class="{
              '!g-bg-grey-600': ['Alternative 1', 'Alternative 2'].includes(glueChoice.type),
              '!g-w-1/2': glueChoices.length === 2,
            }"
            @click="setGlueChoice('Empfehlung')"
            v-if="glueChoices.includes('Empfehlung')"
          >
            Empfehlung
          </div>
          <div
            class="g-w-1/3 g-cursor-pointer g-text-center g-uppercase g-font-bold g-bg-grey-600 g-px-4 g-py-3"
            :class="{ '!g-bg-green-500': glueChoice.type === 'Alternative 1', '!g-w-1/2': glueChoices.length === 2 }"
            @click="setGlueChoice('Alternative 1')"
            v-if="glueChoices.includes('Alternative 1')"
          >
            Alternative 1
          </div>
          <div
            class="g-w-1/3 g-cursor-pointer g-text-center g-uppercase g-font-bold g-bg-grey-400 g-px-4 g-py-3"
            :class="{ '!g-bg-green-500': glueChoice.type === 'Alternative 2', '!g-w-1/2': glueChoices.length === 2 }"
            @click="setGlueChoice('Alternative 2')"
            v-if="glueChoices.includes('Alternative 2')"
          >
            Alternative 2
          </div>
        </div>

        <product-quantity-list :title="glueChoice.name" :options="glueVariations">
          <template #top>
            <div class="g-flex g-justify-between g-pt-2 g-pb-5" v-if="glueAmount">
              <div class="g-w-1/3 g-pr-2">
                <p class="g-font-bold">Verbrauch*</p>
                <p class="g-text-2xl g-font-bold">{{ glueAmount }} liter</p>
                <p class="g-text-sm g-text-grey-600 g-whitespace-nowrap">*es handelt sich hierbei um einen Richtwert</p>
              </div>
              <div class="g-w-2/3 g-pl-2 g-hidden">
                <p class="g-font-bold g-text-green-500">Bahnenempfehlung</p>
                <div class="g-flex">
                  <p class="g-mr-5">1x</p>
                  <p class="g-mr-5">Breite: <strong>4,58m</strong></p>
                  <p>Länge: <strong>6,80m</strong></p>
                </div>
                <div class="g-flex">
                  <p class="g-mr-5">1x</p>
                  <p class="g-mr-5">Breite: <strong>4,58m</strong></p>
                  <p>Länge: <strong>6,80m</strong></p>
                </div>
              </div>
            </div>

            <p class="g-text-lg g-mb-2 g-mt-3">Kleber auswählen</p>
          </template>

          <template #bottom>
            <div class="g-flex g-items-center g-mt-4">
              <gp-icon
                :icon="['fas', 'info-circle']"
                class="g-text-green-500"
                :style="{
                  transform: 'scale(1.3)',
                }"
              />
              <p class="g-ml-2 g-font-bold g-text-lg">Ergänzung</p>
            </div>
            <p>
              {{ texts["5.1"] }}
            </p>

            <li class="g-flex g-pb-4 g-border-grey-200 g-mt-6">
              <div class="g-mr-4">
                <img class="g-w-24" v-if="addOnItemImages[0]" :src="addOnItemImages[0].urlMiddle" />
              </div>

              <div v-if="addOnItemVaration.id">
                <p class="g-text-xl g-font-bold">
                  {{ addOnItemVaration.unit.content }} <span v-if="addOnItemVaration.unit.unitId == 53">ml</span
                  ><span v-if="addOnItemVaration.unit.unitId == 5">Liter</span>
                </p>
                <p class="g-text-sm">{{ addOnItem.texts[0].name1 }}</p>
                <p class="g-text-lg">{{ getPrice(addOnItemVaration) | formatPrice }} EUR</p>
              </div>

              <div class="g-flex g-self-stretch g-items-center g-ml-auto">
                <quantity-input
                  @change="updateAddOnQuantity"
                  :quantity="$store.state.zusammenstellung.basket[addOnItemVaration.id] || 0"
                ></quantity-input>
              </div>
            </li>
          </template>
        </product-quantity-list>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import ProductQuantityList from "../components/ProductQuantityList.vue";
import QuantityInput from "../components/QuantityInput.vue";
import SectionContent from "../components/SectionContent.vue";
import { getAttributeValue, getPrice } from "../plentyHelpers.js";
import ENV from "../environment";

export default {
  components: { SectionContent, ProductQuantityList, QuantityInput },
  name: "Zusammenstellung",

  data() {
    return {
      addOnItem: {},
      addOnItemImages: {},
    };
  },

  async created() {
    let itemRequest = await axios.get(ENV.baseUrl + ENV.itemEndpoint + "?itemId=2303&pluginSetPreview=" + ENV.setPreview);
    if (!itemRequest.data) return;

    let item = itemRequest.data.item;
    let images = await axios.get(ENV.imageEndpoint + `?itemId=2303&pluginSetPreview=${ENV.setPreview}`);

    this.addOnItem = item;
    this.addOnItemImages = images.data.images;
  },

  computed: {
    glueAmount() {
      return this.$store.getters.recomendedGlueAmount;
    },

    addOnItemVaration() {
      return this.addOnItem?.variations?.[0] || {};
    },

    glueChoice() {
      return this.$store.state.untergrund.secondarySelection;
    },

    glueChoices() {
      if (!this.$store.state.untergrund.selection.options) return [];
      return this.$store.state.untergrund.selection.options.filter((option) => option.factor).map((option) => option.type);
    },

    glueVariations() {
      return this.$store.getters.glueVariations;
    },

    dachbahnVariations() {
      return this.$store.getters.dachbahnVariations;
    },

    roofArea() {
      return this.$store.getters.roofArea;
    },

    chosenArea() {
      let dachbahnVariationIds = this.dachbahnVariations.map((variation) => variation.id);
      let quantities = {};
      let area = 0;

      dachbahnVariationIds.forEach(
        (variationId) => (quantities[variationId] = this.$store.state.zusammenstellung.basket[variationId] || 0)
      );

      for (const variationId in quantities) {
        if (Object.hasOwnProperty.call(quantities, variationId)) {
          const length = quantities[variationId];
          let variation = this.dachbahnVariations.find((variation) => variation.id == variationId);
          let width = Number(this.getAttributeValue(variation, "Bahnbreite ElastoTop"));
          area = area + width * length;
        }
      }

      return area;
    },

    mainTitle() {
      return "Entscheiden Sie selbst";
    },

    body() {
      return "Condimentum dapibus urna sodales elit dignissim sociosqu nunc finibus dictum fusce adipiscing taciti felis sed a magna vulputate lectus inceptos, malesuada volutpat platea lobortis praesent per lacinia senectus.";
    },

    gebaeudeArt() {
      return this.$store.state.gebaeudeart.secondarySelection;
    },

    texts() {
      return this.$store.state.inhalt.texts;
    },
  },

  methods: {
    getAttributeValue,
    getPrice,

    updateAddOnQuantity(quantity) {
      this.$store.commit("zusammenstellung/setBasketItem", { variationId: this.addOnItemVaration.id, quantity });
    },

    setGlueChoice(choice) {
      let option = this.$store.state.untergrund.selection?.options.find((option) => option.type === choice);
      this.$store.dispatch("untergrund/selectSecondaryOption", option);
    },

    setDachbahnChoices() {
      let width = this.$store.getters["abmessungen/totalWidth"];
      let height = this.$store.getters["abmessungen/totalDepth"];

      // Calculate choices for both orientations
      let widthChoices = this.calculateFit(width, height);
      let heightChoices = this.calculateFit(height, width);
      let choices = widthChoices;

      // Calcuate area for both orientations (flip 90 deg) and select lowest area
      let widthArea = Object.values(widthChoices).reduce((total, choice) => total + choice.area, 0);
      let heightArea = Object.values(heightChoices).reduce((total, choice) => total + choice.area, 0);

      if (widthArea > heightArea) choices = heightChoices;

      // Set all variations to 0
      this.dachbahnVariations.forEach((variation) => {
        this.$store.commit("zusammenstellung/setBasketItem", { variationId: variation.id, quantity: 0 });
      });

      // Set the correct quantity (length) for each chosen variation
      for (const variationId of Object.keys(choices)) {
        this.$store.commit("zusammenstellung/setBasketItem", { variationId, quantity: choices[variationId].length });
      }

      return choices;
    },

    calculateFit(width, height) {
      let bahnen = {};
      let choices = {};

      this.dachbahnVariations.forEach((variation) => {
        let bahnbreite = this.getAttributeValue(variation, "Bahnbreite ElastoTop");
        bahnen[bahnbreite] = variation;
      });

      let breiten = Object.keys(bahnen);
      let totalArea = 0;

      const fitBahn = (width) => {
        // Sort breiten hight to low
        breiten.sort((a, b) => Number(a) - Number(b));
        let rest = 0;

        // Find the closest bahn
        let closestBahn = breiten.find((b) => Number(b) >= width);
        if (!closestBahn) closestBahn = breiten[breiten.length - 1];
        if (closestBahn < width) rest = width - closestBahn;

        let variation = bahnen[closestBahn];

        if (variation) {
          choices[variation.id] = {
            length: (choices[variation.id] || 0) + Number(height),
            width: Number(closestBahn),
            area: Number(closestBahn) * ((choices[variation.id] || 0) + Number(height)),
          };
        }

        if (rest > 0) fitBahn(rest);
        return true;
      };

      fitBahn(width);

      return choices;
    },
  },

  props: ["position", "description"],

  watch: {
    roofArea() {
      this.$nextTick(() => {
        this.setDachbahnChoices();
      });
    },

    gebaeudeArt() {
      this.$nextTick(() => {
        this.setDachbahnChoices();
      });
    },
  },
};
</script>

<style></style>
